export type Priority = 'P0' | 'P1' | 'P2' | 'P3';
export type Status = 'backlog' | 'in_progress' | 'blocked' | 'done' | 'cancelled';
export type Category =
  | 'feature' | 'fix' | 'compliance' | 'release'
  | 'business' | 'research' | 'design' | 'ops';
export type Phase =
  | 'discovery' | 'mvp' | 'beta' | 'live' | 'sunset' | 'blocked';

export interface Holding {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  color: string | null;
  position: number;
}

export interface App {
  id: string;
  holding_id: string;
  slug: string;
  name: string;
  description: string | null;
  domain: string | null;
  phase: Phase;
  stack_notes: string | null;
  position: number;
}

export interface Initiative {
  id: string;
  app_id: string;
  title: string;
  description: string | null;
  category: Category;
  status: Status;
  priority: Priority;
  owner: string | null;
  blockers: string | null;
  start_date: string | null;
  target_date: string | null;
  completed_at: string | null;
  position: number;
  created_at: string;
  updated_at: string;
}

export interface Milestone {
  id: string;
  initiative_id: string;
  title: string;
  completed: boolean;
  completed_at: string | null;
  position: number;
}

export interface RoadmapLink {
  id: string;
  initiative_id: string;
  label: string;
  url: string;
  kind: 'link' | 'pr' | 'doc' | 'memo' | 'dashboard' | 'repo';
}

export const PRIORITIES: Priority[] = ['P0', 'P1', 'P2', 'P3'];
export const STATUSES: Status[] = ['backlog', 'in_progress', 'blocked', 'done', 'cancelled'];
export const CATEGORIES: Category[] = ['feature', 'fix', 'compliance', 'release', 'business', 'research', 'design', 'ops'];
export const PHASES: Phase[] = ['discovery', 'mvp', 'beta', 'live', 'sunset', 'blocked'];

export const STATUS_LABEL: Record<Status, string> = {
  backlog: 'Backlog',
  in_progress: 'En curso',
  blocked: 'Bloqueada',
  done: 'Hecho',
  cancelled: 'Cancelada',
};

export const CATEGORY_LABEL: Record<Category, string> = {
  feature: 'Feature',
  fix: 'Fix',
  compliance: 'Compliance',
  release: 'Release',
  business: 'Business',
  research: 'Research',
  design: 'Design',
  ops: 'Ops',
};

export const PHASE_LABEL: Record<Phase, string> = {
  discovery: 'Discovery',
  mvp: 'MVP',
  beta: 'Beta',
  live: 'Live',
  sunset: 'Sunset',
  blocked: 'Bloqueada',
};
